import { createContext } from "react";
import { WINDOW_NAME } from "../fields.js";
const RPCInstanceContext = createContext({});
const TARGET_TYPE_STRINGS = Object.freeze({
    BroadcastChannel: '[object BroadcastChannel]',
    WebSocket: '[object WebSocket]',
    Window: WINDOW_NAME,
    ServiceWorkerRegistration: '[object ServiceWorkerRegistration]',
    ServiceWorkerGlobalScope: '[object ServiceWorkerGlobalScope]',
    SharedWorker: '[object SharedWorker]',
    SharedWorkerGlobalScope: '[object SharedWorkerGlobalScope]',
    Worker: '[object Worker]',
    DedicatedWorkerGlobalScope: '[object DedicatedWorkerGlobalScope]'
});
export { RPCInstanceContext, TARGET_TYPE_STRINGS };
